import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: CartFooter
 */
export function CartFooter() {
  console.log("CartFooter mounted.");
}
